import { LoggedUser, UsersStructure } from "../structures";
import { USERS } from "../actions-constants/users.constants";
import { UserIdha } from "@idha/idha-types";

const initialUserStructure:UsersStructure = {userList:[],exchangeUserVisible:false}

export function usersReducer(usersData: UsersStructure = initialUserStructure, action):UsersStructure {    
    switch (action.type) {        
        case USERS.SET_USER_LIST:
            let userList = (action.userList.map(a=>({...a})))||[];
            return {...usersData,userList:userList};
        case USERS.SET_USER_EXCHANGE_DIALOG_VISIBILITY:
            return {...usersData,exchangeUserVisible:action.exchangeUserVisible}
        default:
            return usersData||{...initialUserStructure};
    }
}